import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';

import { API_URL } from '../../injection-tokens';
import { CreateRelationshipParams, LegislatorApiError, ProblemDetails } from './legislator-api.types';

@Injectable({ providedIn: 'root' })
export class LegislatorApiService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = `${inject(API_URL)}/legislator`;

    createRelationship(params: CreateRelationshipParams): Observable<string> {
        const queryParams = new HttpParams()
            .set('legislatorGuid', params.legislatorGuid)
            .set('individualGuid', params.individualGuid)
            .set('relationship', params.relationship);

        return this.http
            .post<string>(`${this.baseUrl}/Legislators/CreateRelationship`, null, { params: queryParams })
            .pipe(
                map((r) => r),
                catchError((error: HttpErrorResponse) => {
                    const problemDetails = this.getProblemDetails(error.error);
                    const legislatorApiError: LegislatorApiError = {
                        status: error.status,
                        message: this.getErrorMessage(error, problemDetails),
                        problemDetails,
                        originalError: error,
                    };

                    return throwError(() => legislatorApiError);
                }),
            );
    }

    private getProblemDetails(error: unknown): ProblemDetails | undefined {
        if (error && typeof error === 'object' && 'title' in error) {
            return error as ProblemDetails;
        }
        return undefined;
    }

    private getErrorMessage(error: HttpErrorResponse, problemDetails?: ProblemDetails): string {
        return problemDetails?.detail ?? problemDetails?.title ?? error.message;
    }
}
